import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchCropFields(agro_exporter_id, producer_id, filters = {}) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/list_crop_fields/${agro_exporter_id}/${producer_id}`,
      { params: filters }
    );
  },
  fetchProducer(agro_exporter_id, producer_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/list_crop_fields/${agro_exporter_id}/producer/${producer_id}`
    );
  },
  fetchQualityTemplates(agro_exporter_id, producer_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/crop_field/list_crop_fields/${agro_exporter_id}/quality_templates/${producer_id}`
    );
  },
};
